// Is a given value a DOM element?
export default function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isElement.js
// module id = 491
// module chunks = 8